import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { CopyIcon } from "../../images";
import { CustomAudio } from "./Common";
import { time_to_second, second_to_time } from "./utils/functions";
import "@lottiefiles/lottie-player";
import * as typingIndicator_json from "../../images/demo/main_section/TypingIndicator";
import { error } from "jquery";
import { errorNotify, successNotify } from "../notify/toastify";

export const SIMPLE_TEXT = "simple-text";
export const TIMING_TEXT = "timing-text";

const FinalResponseHeader = (props) => {
  const { classNames, handleActiveTab, activeTab, ...restProps } = props;

  return (
    // set key for detect difference between elements that has `header` classname that cause work animation in every rerender.
    // when the div re-renders, react only changes its inner text. Adding a key will make react think it's a different div when the key changes, so it'll unmount it and mount again.
    <div
      key='response-header'
      className={`header ${classNames}`}
      {...restProps}
    >
      <span
        onClick={() => handleActiveTab("timing-text")}
        className={"left " + (activeTab === TIMING_TEXT ? "active" : "")}
      >
        متن زمان بندی شده
      </span>
      <span
        onClick={() => handleActiveTab("simple-text")}
        className={"right " + (activeTab === SIMPLE_TEXT ? "active" : "")}
      >
        متن ساده
      </span>
    </div>
  );
};

FinalResponseHeader.propTypes = {
  classNames: PropTypes.string,
  handleActiveTab: PropTypes.func.isRequired,
  activeTab: PropTypes.string,
};

FinalResponseHeader.defaultProps = {
  classNames: "",
  activeTab: SIMPLE_TEXT,
};

const FinalResponseText = (props) => {
  /* --------------------------------------- props, states, refs ---------------------- -- */
  const {
    activeTab,
    segments,
    mediaUrl,
    audioDuration,
    isArchive,
    wsConnected,
    activeIcon,
  } = props;

  const [currentTime, setCurrentTime] = useState(0);

  const [clickedTextTime, setClickedTime] = useState(null);

  const textWrapperElementRef = useRef(null);

  const activeSegmentElementRef = useRef(null);

  // for store the previous segments prop and previous currentTime state. Will be updated after complete render(in useEffect)
  const prevSegmentsRef = useRef(null);

  const prevCurrentTimeRef = useRef(null);

  /* ---------------- change start and end in segments,and add numStart, numEnd property for use in render --------- */
  // adding new property and change its in segments code, only need when a new segment come in
  // if (segments !== prevSegmentsRef.current) {
  segments.forEach((segment) => {
    // save start and end as seconds by add numStart and numEnd
    segment.numStart = time_to_second(segment.start);
    segment.numEnd = time_to_second(segment.end);
    // Standardize start and end time for show in render
    segment.start = second_to_time(segment.numStart);
    segment.end = second_to_time(segment.numEnd);
  });
  // }

  /* -------------------------- detect active_segment and active property to it -------------- */
  // detecting active_segment only need when a new currentTime come in
  // if (currentTime !== prevCurrentTimeRef.current) {
  const active_segment_obj = segments.filter((segment) => {
    return (segment.numStart && segment.numEnd) === undefined
      ? false
      : segment.numStart <= currentTime && currentTime < segment.numEnd;
  })[0];
  segments.forEach((segment) => {
    segment.active = "";
  });
  if (active_segment_obj) active_segment_obj.active = "active";
  // }

  /* -------------------------- useEffects: handle scrolls in wrapper_text and store new segment and new currentTime -*/
  useEffect(() => {
    // add has-scroll class when response-text-wrapper need to show scroll.
    const text_wrapper_el = textWrapperElementRef.current;
    const child_el = text_wrapper_el.children[0];
    const hasVerticalScrollbar =
      child_el.scrollHeight >= text_wrapper_el.clientHeight;
    if (hasVerticalScrollbar) text_wrapper_el.classList.add("has-scroll");
  }, [activeTab]);

  useEffect(() => {
    // move scroll to show last new segments that come from server and add to UI, handle scroll and
    // if segments already exist and rendered (prevSegmentsRef.current),
    if (prevSegmentsRef.current && !isArchive) {
      const text_wrapper_el = textWrapperElementRef.current;
      const child_el = text_wrapper_el.children[0];
      const last_child = child_el.lastChild;
      last_child && last_child.scrollIntoView();
    }
    // store new segments(that has been use in rendered UI), in prevSegmentsRef
    prevSegmentsRef.current = segments;
  }, [segments, isArchive]);

  useEffect(() => {
    // move scroll to show segment that active
    const active_element = activeSegmentElementRef.current;
    if (active_element && !isArchive) active_element.scrollIntoView();

    // store new currentTime(that has been use in rendered UI) in prevCurrentTimeRef
    prevCurrentTimeRef.current = currentTime;
  }, [currentTime, isArchive]);

  useEffect(() => {
    // first act useEffect of CustomAudio then act this useEffect.therefore by change clickedTextTime, first audio's time set to clickedTextTime, Then read below line (setClickedTime(null)).
    // set clickedTextTime to null make selectable this selected text, but audio's time not change because of uses "if" sentence in useEffect of CustomAudio: if (clickedTextTime !== null) {...}
    setClickedTime(null);
  }, [clickedTextTime]);

  return (
    <>
      <div
        className={
          "response-text-wrapper " +
          (activeTab !== SIMPLE_TEXT ? "timing-text" : "simple-text")
        }
        ref={textWrapperElementRef}
      >
        {activeTab !== SIMPLE_TEXT ? (
          // set key for detect difference between elements that has `header` classname that cause work animation in every rerender.
          // when the div re-renders, react only changes its inner text. Adding a key will make react think it's a different div when the key changes, so it'll unmount it and mount again.
          <div key={activeTab}>
            {segments.map((segment, index) => {
              return (
                <div
                  className={"segment " + segment.active}
                  key={TIMING_TEXT + index}
                  ref={segment.active ? activeSegmentElementRef : null}
                  onClick={() => setClickedTime(segment.numStart)}
                >
                  <div className='text'>
                    {" "}
                    {segment.text ? segment.text : "[---]"}{" "}
                  </div>
                  <div className='time'>
                    {" "}
                    {segment.start} - {segment.end}{" "}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div>
            {segments.map((segment, index) => {
              return (
                <span
                  className={segment.active}
                  key={SIMPLE_TEXT + index}
                  ref={segment.active ? activeSegmentElementRef : null}
                  onClick={() => setClickedTime(segment.numStart)}
                >
                  {segment.text ? " " + segment.text : "[---]"}
                </span>
              );
            })}
            {wsConnected && (
              <span className='typing-indicator'>
                <lottie-player
                  autoplay
                  loop
                  mode='normal'
                  src={JSON.stringify(typingIndicator_json.default)}
                />
              </span>
            )}
          </div>
        )}
      </div>
      <CustomAudio
        src={mediaUrl}
        controls={true}
        autoPlay={false}
        setCurrentTime={setCurrentTime}
        clickedTextTime={clickedTextTime}
        duration={audioDuration}
        wsConnected={wsConnected}
        classNames='custom-audio'
        activeIcon={activeIcon}
      />
    </>
  );
};

FinalResponseText.propTypes = {
  segments: PropTypes.array.isRequired,
  activeTab: PropTypes.string,
  mediaUrl: PropTypes.string.isRequired,
  audioDuration: PropTypes.number.isRequired,
  isArchive: PropTypes.bool,
  wsConnected: PropTypes.bool.isRequired,
};

FinalResponseText.defaultProps = {
  activeTab: SIMPLE_TEXT,
  isArchive: false,
};

export const ResponseBox = (props) => {
  const { finalResponse, wsConnected, isArchive, classNames, activeIcon } =
    props;


  const [activeTab, handleActiveTab] = useState(SIMPLE_TEXT);
  const final_response = {
    segments: finalResponse.segments || [],
    download_url:
      finalResponse.download_url ||
      finalResponse.url ||
      finalResponse.media_url ||
      finalResponse.file_url ||
      "",
    duration: finalResponse.duration,
    segmentId: finalResponse.segmentId,
  };

  const _handle_copy_txt = () => {
    let simple_texts = "";
    simple_texts = final_response.segments
      .map(segment => segment.text)
      .filter(text => text)
      .join(". ");


    if (navigator.clipboard) {
      navigator.clipboard.writeText(simple_texts).then(
        function () {
          /* clipboard successfully set */
          successNotify({ text: "متن با موفقیت کپی شد" })
        },
        function () {
          /* clipboard write failed */
          errorNotify({ text: "کپی انجام نشد" })
        }
      );
    } else {
      let input_text = document.body.appendChild(
        document.createElement("input")
      );
      input_text.value = simple_texts;
      input_text.focus();
      /* Select the text field */
      input_text.select();
      input_text.setSelectionRange(0, 99999); /* For mobile devices */
      document.execCommand("copy");
      input_text.parentNode.removeChild(input_text);
      successNotify({ text: "متن با موفقیت کپی شد" })
    }
  };

  return (
    <div className={`final-response ${classNames}`}>
      <FinalResponseHeader
        classNames='final-response-header'
        handleActiveTab={handleActiveTab}
        activeTab={activeTab}
      />
      <FinalResponseText
        segments={final_response.segments}
        activeTab={activeTab}
        mediaUrl={final_response.download_url}
        audioDuration={final_response.duration}
        isArchive={isArchive}
        wsConnected={wsConnected}
        activeIcon={activeIcon}
      />
      {!isArchive && (
        <CopyIcon
          height='1.32vw'
          width='1.18vw'
          className='copy-img'
          onClick={_handle_copy_txt}
        />
      )}
    </div>
  );
};

ResponseBox.propTypes = {
  finalResponse: PropTypes.object.isRequired,
  wsConnected: PropTypes.bool.isRequired,
  isArchive: PropTypes.bool,
  classNames: PropTypes.string,
};

// Set default props
ResponseBox.defaultProps = {
  isArchive: false,
  classNames: "",
};

export default ResponseBox;
